module.exports = __webpack_public_path__ + "img/white-curved.4dc196db.jpeg";